import ArrowForwardIos from "@mui/icons-material/ArrowForwardIos";
import { Box, Card, CardContent, IconButton, Switch } from "@mui/material";
import { Typography } from "antd";
import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useRecoilValue } from "recoil";
import { default as api, default as Api } from "../API/api";
import { loginState, WHState } from "../Atom/AtomState";
import AlertComponent from "../CommonComponent/Alert/AlertComponent";
import ButtonComponent from "../CommonComponent/Inputs/ButtonComponent";
import TextComponent from "../CommonComponent/Inputs/TextComponent";
import Loading from "../CommonComponent/LoadingBar/Loading";
import "../CSS/PageCSS/CustomersDetailPage.css";
import RadioComponent from "../CommonComponent/Inputs/RadioComponent";
import SelectComponent from "../CommonComponent/Inputs/SelectComponent";

const { Title } = Typography;
const sexMenu: any = [
  {
    id: 1,
    name: "Men",
  },
  {
    id: 2,
    name: "Women",
  },
];

export default function CustomerDetailPage() {
  const location = useLocation();
  const key = location.state;
  let navigate = useNavigate();
  const LoginState = useRecoilValue(loginState);
  const [divboxHeight, setdivBoxHeight] = useState<number>(0);
  const WH = useRecoilValue(WHState);
  const [alert, setAlert] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [customer, setCustomer] = useState<any>({
    p_id: 0,
    name: "",
    age: 0,
    country: "",
    sex: "",
    email: "",
  });
  const [loading, setLoading] = useState(false);
  const [countrydata, setCountryData] = useState<any>([]);

  const changeTextField = (value: any) => {
    if (value.name == "name") {
      setCustomer((prev: any) => ({
        ...prev,
        name: value.value,
      }));
    } else if (value.name == "age") {
      setCustomer((prev: any) => ({
        ...prev,
        age: value.value,
      }));
    } else if (value.name == "email") {
      setCustomer((prev: any) => ({
        ...prev,
        email: value.value,
      }));
    }
  };
  const changeRadioField = (value: any, index: any) => {
    if (value.name == "sex") {
      setCustomer((prev: any) => ({
        ...prev,
        sex: value.value,
      }));
    }
  };
  const changeSelect = (value: any) => {
    if (value.name == "country") {
      setCustomer((prev: any) => ({
        ...prev,
        country: value.value,
      }));
    }
  };
  const handleSave = () => {
    const getUpdate = async () => {
      setLoading(true);
      const formData = new FormData();
      formData.append("p_id", customer.p_id);
      formData.append("name", customer.name);
      formData.append("age", customer.age);
      formData.append("country", customer.country);
      if (customer.sex && !isNaN(Number(customer.sex))) {
        const matchedSex = sexMenu.find((item: any) => customer.sex == item.id);
        if (matchedSex) {
          formData.append("sex", matchedSex.name);
        }
      }
      formData.append("email", customer.email);

      const updateData = await Api.put(`/Customer/updateCustomers`, formData);
      setLoading(false);
      if (updateData != undefined) {
        navigate(0);
      } else {
        setAlert(true);
        setAlertMessage("고객 정보 수정에 실패하였습니다.");
      }
    };

    if (
      customer.name == "" ||
      customer.age == "" ||
      customer.age == null ||
      customer.country == 1 ||
      customer.sex == ""
    ) {
      setAlert(true);
      setAlertMessage("필수값을 채워주세요.");
    } else {
      getUpdate();
    }
  };

  useEffect(() => {
    if (!LoginState?.manager) {
      navigate("/");
    } else {
      if (key == null) {
        navigate("/NotFoundPage");
      } else {
        if (key.state != "register") {
          const getData = async () => {
            setLoading(true);
            const country = await api.get(`/Customer/getCountryList`);
            const customer = await api.get(
              `/Customer/getCustomerInfo?p_id=${key.p_id}`
            );
            setLoading(false);
            if (country != undefined || customer != undefined) {
              setCountryData(country);
              const newItem = {
                ...customer[0],
                sex: sexMenu.filter(
                  (item: any) => item.name == customer[0].sex
                )[0].id,
              };
              setCustomer(newItem);
            } else {
              setAlert(true);
              setAlertMessage("데이터 조회에 실패하였습니다.");
            }
          };
          getData();
        }
      }
    }
  }, []);

  useEffect(() => {
    const handleResize = () => {
      const div = document.getElementById("divbox") as HTMLElement;
      const DetailControlDiv = document.getElementById(
        "customerDetailControlDiv"
      ) as HTMLElement;
      if (div && DetailControlDiv) {
        setdivBoxHeight(div.clientHeight - DetailControlDiv.clientHeight - 40);
      }
    };

    window.addEventListener("resize", handleResize);
    handleResize();

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  });

  return (
    <div style={{ height: WH.height - 160 }}>
      <Title level={2} className="customerDetailTitle">
        CustomerDetailPage
      </Title>
      <div id="divbox">
        <Card className="customerDetailCard">
          <CardContent
            className="customerDetailCardContent"
            sx={{
              height: divboxHeight,
            }}
          >
            <Box className="customerDetailForm">
              <Title level={4} className="customerDetailName">
                이름
              </Title>
              {key && key.state == "view" ? (
                <Title level={5} className="customerDetailName">
                  <ArrowForwardIos
                    fontSize="small"
                    className="customerAnswerIcon"
                  />
                  {customer.name}
                </Title>
              ) : (
                <TextComponent
                  variant="standard"
                  value={customer.name}
                  name="name"
                  fullWidth
                  onChange={changeTextField}
                />
              )}
            </Box>
            <Box className="customerDetailForm">
              <Title level={4} className="customerDetailName">
                나이
              </Title>
              {key && key.state == "view" ? (
                <Title level={5} className="customerDetailName">
                  <ArrowForwardIos
                    fontSize="small"
                    className="customerAnswerIcon"
                  />
                  {customer.age}
                </Title>
              ) : (
                <TextComponent
                  variant="standard"
                  value={customer.age}
                  name="age"
                  fullWidth
                  type="number"
                  onChange={changeTextField}
                />
              )}
            </Box>
            <Box className="customerDetailForm">
              <Title level={4} className="customerDetailName">
                성별
              </Title>
              {key && key.state == "view" ? (
                <Title level={5} className="customerDetailName">
                  <ArrowForwardIos
                    fontSize="small"
                    className="customerAnswerIcon"
                  />
                  {customer.sex != "" &&
                    sexMenu.filter((item: any) => item.id == customer.sex)[0]
                      .name}
                </Title>
              ) : (
                <RadioComponent
                  value={customer.sex}
                  onChange={(value: any) => changeRadioField(value, 0)}
                  menulist={sexMenu}
                  labelPlacement="end"
                  label={"name"}
                  name="sex"
                />
              )}
            </Box>
            <Box className="customerDetailForm">
              <Title level={4} className="customerDetailName">
                나라
              </Title>
              {key && key.state == "view" ? (
                <Title level={5} className="customerDetailName">
                  <ArrowForwardIos
                    fontSize="small"
                    className="customerAnswerIcon"
                  />
                  {countrydata.length != 0 &&
                    countrydata.filter(
                      (item: any) => item.p_id == customer.country
                    )[0].name}
                </Title>
              ) : (
                <SelectComponent
                  variant="standard"
                  value={customer.country}
                  label={"국가"}
                  name="country"
                  menulist={countrydata}
                  menuvalue="name"
                  onChange={changeSelect}
                  fullWidth
                />
              )}
            </Box>
            <Box className="customerDetailForm">
              <Title level={4} className="customerDetailName">
                이메일
              </Title>
              {key && key.state == "view" ? (
                <Title level={5} className="customerDetailName">
                  <ArrowForwardIos
                    fontSize="small"
                    className="customerAnswerIcon"
                  />
                  {customer.email}
                </Title>
              ) : (
                <TextComponent
                  variant="standard"
                  value={customer.email}
                  name="email"
                  fullWidth
                  onChange={changeTextField}
                />
              )}
            </Box>
          </CardContent>
          <Box id="customerDetailControlDiv">
            {key && key.state != "view" && (
              <ButtonComponent
                fullWidth
                variant="contained"
                onClick={() => handleSave()}
                className="customerSaveButton"
              >
                저장
              </ButtonComponent>
            )}
            <ButtonComponent
              fullWidth
              variant="contained"
              onClick={() => {
                navigate("/CustomersPage");
              }}
              className="customerCancelButton"
            >
              취소
            </ButtonComponent>
          </Box>
        </Card>
      </div>
      {alert && (
        <AlertComponent value={alert} setValue={setAlert} info="error">
          {alertMessage}
        </AlertComponent>
      )}
      {loading && <Loading />}
    </div>
  );
}
